import PermissionCode from '@modules/roles/contantsPermissions';

export interface IPermissionValue {
  FE_KEY: PermissionCode;
  BE_KEY: Array<PermissionCode>;
  TYPE: 'AND' | 'OR';
}

export const custom: { data: Array<IPermissionValue> } = {
  data: [
    {
      FE_KEY: PermissionCode.ACTIVITIES_VIEW_FORM,
      BE_KEY: [
        PermissionCode.ACTIVITIES_VIEW,
        PermissionCode.ACTIVITIES_CREATE,
        PermissionCode.ACTIVITIES_UPDATE,
      ],
      TYPE: 'OR',
    },
    {
      FE_KEY: PermissionCode.FEEDBACKS_VIEW_DETAIL_PAGE,
      BE_KEY: [PermissionCode.FEEDBACKS_REPLY, PermissionCode.FEEDBACKS_VIEW],
      TYPE: 'OR',
    },
  ],
};
